export enum SortDirections {
  ASC = 'asc',
  DESC = 'desc',
}
